import { Box } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

const Flexbox = styled(Box)({
  display: 'flex'
})

export default Flexbox
